<template>
  <div>
    <vxe-grid
      ref="listingTable"
      auto-resize
      highlight-hover-row
      border
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      row-id="amzFtySkuInvMonitorCode"
      :span-method="rowspanMethod"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:fbaInvQty="{ row }">
        <div style="display: flex;justify-items: center;align-items: center;">
          <div class="tag">
            <span
              class="animate-ping tag-sapn absolute"
              :style="{ backgroundColor: row.alertLevelColor }"
            ></span>
            <span
              class="tag-sapn relative"
              :style="{ backgroundColor: row.alertLevelColor }"
            ></span>
          </div>
          <div style="flex: 1;">
            {{ row.fbaInvQty }}
          </div>
        </div>
      </template>
      <template v-slot:ftyInvQty="{ row }">
        <div style="display: flex;justify-items: center;align-items: center;">
          <div class="tag">
            <span
              class="animate-ping tag-sapn absolute"
              :style="{ backgroundColor: row.skuAlertLevelColor }"
            ></span>
            <span
              class="tag-sapn relative"
              :style="{ backgroundColor: row.skuAlertLevelColor }"
            ></span>
          </div>
          <div style="flex: 1;">
            {{ row.ftyInvQty }}
          </div>
        </div>
      </template>
      <template v-slot:skuInfo="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:goodsColor="{ row }">
        <div>COLOR:{{ row.goodsColor }} {{ row.goodsColorEn }}</div>
        <div>SIZE:{{ row.goodsSize }}</div>
      </template>
      <template v-slot:amzSkuNo="{ row }">
        <div>{{ row.ncNo }}</div>
        <div>{{ row.amzSkuNo }}</div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_tips_del') || '移除关注'"
            placement="top"
            v-if="allow('R')"
          >
            <i class="el-icon-circle-close tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    del({ amzFtySkuInvMonitorCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .ecomAmzListingFtySkuMonitorDelApi({
            amzFtySkuInvMonitorCode,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    rowspanMethod({ row, column }) {
      const notMerger = [
        'operateName',
        'marketName',
        'avgSalesVolume7d',
        'fbaInvQty',
      ]
      if (notMerger.includes(column.property)) {
        return { rowspan: 1, colspan: 1 }
      } else {
        return { rowspan: row.rowspan, colspan: 1 }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes ping {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1.5s cubic-bezier(0, 0, 0.1, 0.6) infinite;
}
.tag {
  position: relative;
  display: inline-flex;
  justify-content: center;
  flex: 1;
}
.tag-sapn {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  opacity: 0.75;
  display: inline-flex;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
</style>
